<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator">
            <div class="control-block-left" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1)">
                <div class="flex mob-inline">
                    <project-select :user="info.User" @onChange="onProjectChange"></project-select>
                </div>
            </div>
        </div>

        <div class="body-panel-content body-panel-content-page">
            <div class="mob-flex-to-block height-full mob-height-auto material-conteiner">

                <div class="test-result-header flex">
                    <div :class="['test-result-header-div', {'select': activeTab === 'notification'}]" @click="onTabChange('notification')">Уведомления</div>
                    <div :class="['test-result-header-div', {'select': activeTab === 'sms'}]" @click="onTabChange('sms')">SMS</div>
                    <div :class="['test-result-header-div', {'select': activeTab === 'email'}]" @click="onTabChange('email')">Email</div>
                    <!--<div :class="['test-result-header-div', {'select': activeTab === 'stats'}]" @click="onTabChange('stats')">Статистика</div>-->
                    <div :class="['test-result-header-div', {'select': activeTab === 'history'}]" @click="onTabChange('history')">История</div>
                    <div :class="['test-result-header-div', {'select': activeTab === 'log'}]" @click="onTabChange('log')">Сервисные сообщения</div>
                </div>
                <div class="material-body" :style="{display: activeTab === 'email' || activeTab === 'sms' || activeTab === 'notification' ? 'block' : 'none'}">
                    <div class="flex m-s-cont">
                        <div class="m-s-cont-left">
                            <div v-if="!templatesByCurrentType.length">
                                Нажмите на "+", чтобы добавить шаблон
                            </div>
                            <div v-for="(template, index) of templatesByCurrentType"
                                 :class="['m-s-cont-tmpl ', {'active': currentTemplate != null && template.Id == currentTemplate.Id}]" @click="onTemplateSelect(template)">
                                <div style="float: right; margin-top: 10px;">
                                    <button type="button" class="btn btn-default btn-img" @click.stop="onRemoveTemplate(template, index)">
                                        <img src="../../img/icon-del.png" alt="" />
                                    </button>
                                </div>
                                <span class="m-s-cont-tmpl-item-header">
                                    {{template.Name}}
                                    <template v-if="template.Id === 0">
                                        *
                                    </template>
                                </span>
                                <div class="m-s-cont-tmpl-item-info">
                                    {{template.CreateDate | date-long}}<br>
                                    Автор: {{template.CreatorFio}}
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary margin-top-15 btn-img" title="Добавить"
                                    @click="addTemplate()" v-if="showAddTemplateBtn">
                                <img src="../../img/icon-plus-2.png" alt="" />
                            </button>
                        </div>
                        <div class="m-s-cont-right">
                            <template v-if="currentTemplate != null">
                                <label class="input-text-lbl" v-if="activeTab === 'sms' || activeTab === 'notification'">
                                    Название шаблона (макс. 250 символов)
                                </label>
                                <label class="input-text-lbl" v-if="activeTab === 'email'">
                                    Тема письма (макс. 250 символов)
                                </label>
                                <input name="TemplateName" type="text"
                                       :class="['input-text', {'input-error': errors.has('TemplateName')}]"
                                       v-validate="{required: true, max: 250}"
                                       v-model="currentTemplate.Name">

                                <template v-if="activeTab === 'email'">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Адрес для отправки
                                        </label>
                                        <drop-down :items="smtpSettings"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   v-model="smtpServerId"></drop-down>
                                    </div>
                                </template>
                                <template v-if="activeTab === 'notification'">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Заголовок уведомления (макс. 128 символов)
                                        </label>
                                        <input name="TemplateHeader" type="text"
                                               :class="['input-text', {'input-error': errors.has('TemplateHeader')}]"
                                               v-validate="{required: true, max: 128}"
                                               v-model="currentTemplate.Header">
                                    </div>
                                </template>

                                <div class="sender-template-info">
                                    <div class="m-s-cont-send-autotmpl">
                                        <p class="input-text-lbl">Автоподставляемые значения</p>
                                        <div class="btns">
                                            <button type="button" class="btn" @click="onPushTemplateVariable('%ФИО%')">Полное ФИО</button>
                                            <button type="button" class="btn" @click="onPushTemplateVariable('%Фамилия%')">Фамилия</button>
                                            <button type="button" class="btn" @click="onPushTemplateVariable('%Имя%')">Имя</button>
                                            <button type="button" class="btn" @click="onPushTemplateVariable('%Отчество%')">Отчество</button>
                                            <button type="button" class="btn" @click="onPushTemplateVariable('%БаллыАктивные%')">Сколько баллов активно</button>
                                            <button type="button" class="btn" @click="onPushTemplateVariable('%БаллыПотенциальные%')">Сколько баллов будет активно</button>
                                            <button type="button" class="btn" @click="onPushTemplateVariable('%АктивацияАккаунта%')">Активация аккаунта</button>
                                            <button type="button" class="btn" @click="onPushTemplateVariable('%БаллыТекМесяц%')">БаллыТекМесяц</button>
                                        </div>
                                    </div>
                                    <div>
                                        <label class="input-text-lbl">
                                            Сообщение
                                        </label>
                                        <textarea name="SmsBody" style="height:150px" rows="10" class="input-memo" ref="smsBody" v-if="activeTab === 'sms'"
                                                  v-model="currentTemplate.Body" @change="calculateSmsTextInfo" @keyup="calculateSmsTextInfo"></textarea>

                                        <froala-editor ref="EmailBody" name="EmailBody" v-model="currentTemplate.Body" v-if="activeTab === 'email' || activeTab === 'notification'"></froala-editor>
                                        <div style="text-align: right;" v-if="activeTab === 'sms'">
                                            {{smsTextInfo.symbolsLeft}}/{{smsTextInfo.symbolsTotal}}
                                            ({{smsTextInfo.messages}} сообщение)
                                        </div>
                                    </div>



                                    <div class="m-s-cont-send-filter margin-top-10">
                                        <div class="flex">
                                            <div class="form-field" style="width:200px;min-width:200px">
                                                <label class="input-text-lbl">
                                                    Роль пользователя
                                                </label>
                                                <drop-down :items="roles"
                                                           :dataField="'Id'"
                                                           :textField="'Name'"
                                                           v-model="roleId"
                                                           @change="onRoleChange"></drop-down>
                                            </div>

                                            <div class="margin-left-20 margin-top-20">
                                                <p>Отфильтровано пользователей: {{usersCount}}</p>
                                                <p>Выбрано для отправки: {{resultUsersCount}}</p>
                                            </div>
                                            <div class="margin-left-20 margin-top-20 flex btns" style="height:34px">
                                                <button type="button" class="btn" @click.stop="openCurrentUsers()">Уточнить выбор</button>
                                                <button type="button" class="btn" @click="clearFilterState">Очистить</button>
                                            </div>
                                        </div>
                                        <template v-if="activeTab === 'sms'">
                                            <p>Примерная стоимость: {{smsTextInfo.averagePrice}} руб.</p>
                                        </template>
                                    </div>
                                </div>

                                <div class="margin-top-30">
                                    <div class="btns flex">
                                        <button type="button" class="btn" @click.stop="onTemplateSave()">Сохранить шаблон</button>
                                        <button type="button" class="btn" @click.stop="onSendToMe">Отправить мне</button>
                                        <button type="button" class="btn"
                                                @click.stop="onStartSending()"
                                                :disabled="activeTab === 'sms' && !smsSendingAllowed"
                                                :title="activeTab !== 'sms' || smsSendingAllowed ? '' : 'Будет превышен дневной лимит отправки сообщений'">
                                            {{startSendingText}}
                                        </button>
                                        <div class="margin-top-5" v-if="activeTab === 'sms' && smsLimits != null">Дневной лимит {{smsLimits.today}} из {{smsLimits.total}}</div>
                                    </div>
                                </div>
                                <div class="form-field flex margin-top-5" v-if="activeTab === 'notification'">
                                    <div class="margin-right-20">
                                        <label class="input-text-lbl">Запланировать отправку</label>
                                        <div class="input-date-lbl">
                                            <input-date name="DateStartSent" v-model="dateStartSent" class="input-text" todayHighlight="true"></input-date>
                                        </div>
                                    </div>
                                    <div>
                                        <label class="input-text-lbl">Время</label>
                                        <input-time name="TimeStartSent" showSeconds="true" maxHours="23" v-model="timeStartSent" class="input-text"></input-time>
                                    </div>
                                </div>
                            </template>
                            <div v-else>
                                Выберите шаблон в левой колонке
                            </div>
                        </div>
                    </div>
                </div>

                <div class="material-body" :style="{display: activeTab === 'history' ? 'block' : 'none'}">
                    <div class="m-s-cont">
                        <div class="flex margin-top-15" style="width: 50%;">
                            <div class="form-field">
                                <drop-down class="" :items="bulkSendingTypes" :dataField="'Id'" :textField="'Name'" v-model="historyBulkSendingType" @change="bulkSendingReload"></drop-down>
                            </div>
                            <div class="flex margin-left-10">
                                <input-date name="dateStart" v-model="historyDateStart" @input="bulkSendingReload" class="input-text input-date"></input-date>
                                <span class="margin-left-10 margin-right-10 margin-top-5">-</span>
                                <input-date name="dateEnd" v-model="historyDateEnd" @input="bulkSendingReload" class="input-text input-date"></input-date>
                            </div>
                            <div class="margin-left-20">
                                <button type="button" class="btn" @click.stop="onHistoryFilterClear()">Сбросить</button>
                            </div>
                            <div class="margin-left-20">
                                <button class="btn" @click="onExportDetails()">Экспорт</button>
                            </div>

                        </div>

                        <table class="t-data" style="margin:20px 0 0;">
                            <thead>
                                <tr class="heading">
                                    <th class="fix"></th>
                                    <th class="number-short">Id</th>
                                    <th class="w150-c">Тип</th>
                                    <th class="w150-c">Дата</th>
                                    <th class="w200">Шаблон</th>
                                    <th>Прогресс</th>
                                    <!--<th>отправлено</th>
                                <th>доставлено</th>
                                <th>не доставлено</th>
                                <th>всего получаетелей</th>-->
                                    <th class="number">Стоимость</th>
                                    <!--<th>статус </th>-->
                                    <th class="w100-c">Детали</th>
                                    <th class="fix-2"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(history) of bulkSending.data" @click.stop="onReceiversClick(history)">
                                    <td class="number-short">
                                        {{history.Id}}
                                    </td>
                                    <td class="w150-c">{{history.BulkSendingType}}</td>
                                    <td class="w150-c">{{ history.CreateDate | date-long}}</td>
                                    <td class="t-data-str w200">{{history.TemplateName}}</td>
                                    <td>
                                        <div class="progress-line">
                                            <div class="progress-line-col green" :style="[{left:0}, {width: (history.DeliveredCount / history.ReceiversCount * 100) + '%'}]"></div>
                                            <div class="progress-line-col yellow" :style="[{left: (history.DeliveredCount / history.ReceiversCount * 100) + '%'}, {width: ((history.SentCount - history.DeliveredCount - history.NotDeliveredCount) / history.ReceiversCount * 100) + '%'}]"></div>
                                            <div class="progress-line-col red" :style="[{left: ((history.SentCount - history.NotDeliveredCount) / history.ReceiversCount * 100) + '%'}, {width: (history.NotDeliveredCount / history.ReceiversCount * 100) + '%'}]"></div>
                                            <div class="progress-line-col grey" :style="[{right:0}, {width: (history.NotSentCount / history.ReceiversCount * 100) + '%'}]"></div>
                                        </div>

                                        <!--{{getProgressLine(history.ReceiversCount, history.NotSentCount, history.SentCount, history.DeliveredCount, history.NotDeliveredCount)
                                            }}-->
                                        <!--{{history.NotSentCount}} / {{history.SentCount}} / {{history.DeliveredCount}} / {{history.NotDeliveredCount}} / {{history.ReceiversCount}}-->

                                    </td>

                                    <!--<td>{{history.SentCount}}</td>
                                <td>{{history.DeliveredCount}}</td>
                                <td>{{history.NotDeliveredCount}}</td>
                                <td>{{history.ReceiversCount}}</td>-->
                                    <td class="number">{{formatInt(history.TotalCost)}}</td>

                                    <!--<td>{{history.StatusFormatted}}</td>-->
                                    <td class="w100-c">
                                        <button type="button" class="btn btn-img" @click.stop="onReceiversClick(history)">
                                            >

                                            <img src="../../img/icon-analit.png" alt="">
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="material-body" :style="{display: activeTab === 'log' ? 'block' : 'none'}">
                    <div class="m-s-cont">

                        <table class="t-data" style="margin:20px 0 0;">
                            <thead>
                                <tr class="heading">
                                    <th class="w50-c">Id</th>
                                    <th class="w150-c">Дата</th>
                                    <th>Сообщение</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item of log.data">
                                    <td class="w50-c">
                                        {{item.Id}}
                                    </td>
                                    <td class="w150-c">{{ item.CreateDate | date-long}}</td>
                                    <td class="t-data-str">{{item.Message}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>

        <popup-window ref="ppCurrentUsers" :title="'Получатели рассылки'" @onBottomScrolled="onCurrentUsersSroll" width="95%" height="95%" @click.stop="" @onClose="ppCurrentUsersClosed()">
            <div>
                <div>
                    <div class="flex">
                        <div class="form-field" style="width:200px;min-width:200px">
                            <label class="input-text-lbl">
                                Роль пользователя
                            </label>
                            <drop-down :items="roles"
                                       :dataField="'Id'"
                                       :textField="'Name'"
                                       v-model="roleId"
                                       @change="onRoleChangeFromPopup"></drop-down>
                        </div>
                        <div class="margin-left-20" style="width:100%">
                            <p class="input-text-lbl">Фильтрация по датам</p>
                            <div class="flex">
                                <div class="form-field" style="width:250px">
                                    <drop-down class="" :items="dateSortTypes" :dataField="'Id'" :textField="'Name'" v-model="dateSortType" @change="onSortTypeChange($event)"></drop-down>
                                </div>
                                <div class="flex margin-left-10" v-if="!dateSortEmpty">
                                    <input-date name="dateStart" v-model="dateStart" @input="onDateChange" class="input-text input-date"></input-date>
                                    <span class="margin-left-10 margin-right-10 margin-top-5">-</span>
                                    <input-date name="dateEnd" v-model="dateEnd" @input="onDateChange" class="input-text input-date"></input-date>
                                </div>
                                <div class="flex margin-left-10" style="min-width:100px;padding-top:7px">
                                    <input :id="'dateSortEmpty'" v-model="dateSortEmpty" value="true" type="checkbox" class="input-checkbox" @change="onDateSortEmptyChange()" />
                                    <label :for="'dateSortEmpty'" class="input-checkbox-lbl">Пустая&nbsp;дата</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="margin-top-10">
                        <p class="input-text-lbl">Динамические фильтры</p>
                        <complex-filter ref="complexFilter"
                                        :filters="userFilters"
                                        :searchFunction="searchFunction"
                                        :tableName="'[dbo].[AspNetUsers]'"
                                        @onFilterChange="onFilterChange"
                                        :withTableNameInClause="true"
                                        cacheKey="senderCurrentUsersFilterKey"></complex-filter>
                    </div>
                </div>

                <div class="margin-top-15" style="margin-left:21px">
                    <input id="currentSelectAll" type="checkbox" class="input-checkbox"
                           v-model="allCurrentUsersSelected" @change.stop="currentUsersSelectAll" />
                    <label for="currentSelectAll" class="input-checkbox-lbl no-wrap">
                        Выбрать всех
                    </label>
                </div>

                <table class="table-view margin-top-5">
                    <tbody>
                        <tr v-for="(user, u) of users.data" @click="user.Included = !user.Included">
                            <td class="bit">
                                <input :id="'user_' + u" v-model="user.Included" value="true" type="checkbox" class="input-checkbox" />
                                <label :for="'user_' + u" class="input-checkbox-lbl no-text" @click.stop=""></label>
                            </td>
                            <td>
                                {{user.Fio}}
                            </td>
                            <td>
                                {{user.Email}}
                            </td>
                            <td>
                                {{user.PhoneNumber}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <template v-slot:footer>
                <div class="popup-footer">
                    <div class="flex">
                        <div style="width:50%">
                            Отфильтровано: {{usersCount}}, выбрано {{resultUsersCount}}
                        </div>
                        <div class="btns flex" data-toggle="buttons" style="justify-content: flex-end;width:50%">
                            <button type="button" class="btn" @click="onCurrentUsersExport()">
                                Экспорт
                            </button>
                            <button type="button" class="btn" @click.stop="closeModal('ppCurrentUsers')">Закрыть</button>
                        </div>
                    </div>

                </div>
            </template>
        </popup-window>

        <popup-window ref="ppReceivers" :title="'Детализация рассылки'" @onBottomScrolled="onReceiversSroll" width="800">
            <div>
                <div v-if="receivers.BulkSendingTypeId==3 && receivers.AllowEdit" class="form-field">
                    <p class="input-text-lbl" @click.stop="onReceiversSheduleClick" style="cursor:pointer;">Запланированное уведомление. Подробнее</p>
                    <div class="line-separator margin-bottom-15 margin-top-15"></div>
                </div>
                <div class="flex">
                    <div class="send-view">
                        <p class="input-text-lbl">Текст сообщения</p>
                        <div class="margin-top-5" v-html="receivers.body" style=""></div>
                    </div>
                    <div class="send-view-chart">
                        <chart :type="'doughnut'" :chartOptions="chartOptions" :chartData="chartData"></chart>
                    </div>
                </div>
                <div class="margin-top-5" style="text-align:center">Всего получателей: {{receivers.RecTotal}}</div>
                <table class="table-view margin-top-20">
                    <thead style="display: table-header-group !important;">
                        <tr>
                            <th>ФИО</th>
                            <th>Статус</th>
                            <th v-if="receivers.bulkSendingType === 'SMS'">Цена</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, u) of receivers.data">
                            <td>
                                {{user.Fio}}
                            </td>
                            <td class="state">
                                {{user.StatusFormatted}}
                            </td>
                            <td v-if="receivers.bulkSendingType === 'SMS'" class="valueshort">
                                {{ formatInt((user.Cost || 0).toFixed(2))}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <template v-slot:footer>
                <div class="popup-footer">
                    <div class="btns flex" data-toggle="buttons" style="justify-content: flex-end;">
                        <button type="button" class="btn" @click="onRepeat()">Повторить</button>
                        <button type="button" class="btn" @click="onExportDetails(receivers.id)">
                            Экспорт
                        </button>
                        <button type="button" class="btn" @click="closeModal('ppReceivers')">Закрыть</button>
                    </div>
                </div>
            </template>
        </popup-window>

        <popup-window ref="ppReceiversShedule" :title="'Запланированное уведомление'" width="800">
            <div>
                <div class="form-field flex">
                    <div class="margin-right-20">
                        <label class="input-text-lbl">Дата отправки</label>
                        <div class="input-date-lbl">
                            <input-date name="StartDate" v-model="currentTemplate.StartDateFormatted" class="input-text" todayHighlight="true"></input-date>
                        </div>
                    </div>

                    <div>
                        <label class="input-text-lbl">Время отправки</label>
                        <input-time name="StartSendTime"
                                    showSeconds="true"
                                    maxHours="23"
                                    v-model="currentTemplate.StartSendTimeFormatted"
                                    :class="['input-text', {'input-error': errors.has('StartSendTime')}]"></input-time>
                    </div>
                </div>

                <div class="form-field">
                    <label class="input-text-lbl">
                        Название шаблона (макс. 250 символов)
                    </label>
                    <input name="SheduleTemplateName" type="text"
                           :class="['input-text', {'input-error': errors.has('SheduleTemplateName')}]"
                           v-validate="{required: true, max: 250}"
                           v-model="currentTemplate.Name">
                </div>

                <div class="form-field">
                    <label class="input-text-lbl">
                        Заголовок уведомления (макс. 128 символов)
                    </label>
                    <input name="SheduleTemplateHeader" type="text"
                           :class="['input-text', {'input-error': errors.has('SheduleTemplateHeader')}]"
                           v-validate="{required: true, max: 128}"
                           v-model="currentTemplate.Header">
                </div>

                <div class="sender-template-info">
                    <div class="m-s-cont-send-autotmpl">
                        <p class="input-text-lbl">Автоподставляемые значения</p>
                        <div class="btns">
                            <button type="button" class="btn" @click="onPushSheduleTemplateVariable('%ФИО%')">Полное ФИО</button>
                            <button type="button" class="btn" @click="onPushSheduleTemplateVariable('%Фамилия%')">Фамилия</button>
                            <button type="button" class="btn" @click="onPushSheduleTemplateVariable('%Имя%')">Имя</button>
                            <button type="button" class="btn" @click="onPushSheduleTemplateVariable('%Отчество%')">Отчество</button>
                            <button type="button" class="btn" @click="onPushSheduleTemplateVariable('%БаллыАктивные%')">Сколько баллов активно</button>
                            <button type="button" class="btn" @click="onPushSheduleTemplateVariable('%БаллыПотенциальные%')">Сколько баллов будет активно</button>
                            <button type="button" class="btn" @click="onPushSheduleTemplateVariable('%АктивацияАккаунта%')">Активация аккаунта</button>
                            <button type="button" class="btn" @click="onPushSheduleTemplateVariable('%БаллыТекМесяц%')">БаллыТекМесяц</button>
                        </div>
                    </div>
                    <div>
                        <label class="input-text-lbl">Сообщение</label>
                        <froala-editor ref="SheduleEmailBody" name="SheduleEmailBody" v-model="currentTemplate.Body"></froala-editor>
                    </div>

                    <div class="m-s-cont-send-filter margin-top-10">
                        <div class="flex">
                            <div class="form-field" style="width:200px;min-width:200px">
                                <label class="input-text-lbl">
                                    Роль пользователя
                                </label>
                                <drop-down :items="roles"
                                           :dataField="'Id'"
                                           :textField="'Name'"
                                           v-model="roleId"
                                           @change="onRoleChange"></drop-down>
                            </div>

                            <div class="margin-left-20 margin-top-20">
                                <p>Отфильтровано пользователей: {{usersCount}}</p>
                                <p>Выбрано для отправки: {{resultUsersCount}}</p>
                            </div>
                            <div class="margin-left-20 margin-top-20 flex btns" style="height:34px">
                                <button type="button" class="btn" @click.stop="openCurrentUsers(); closeModal('ppReceiversShedule');">Уточнить выбор</button>
                                <button type="button" class="btn" @click="clearFilterState">Очистить</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot='footer' class="popup-footer">
                <div class="btns" data-toggle="buttons">
                    <button type="button" class="btn" @click.stop="onBulkSendingDelete" style="float: left;">Отменить отправку</button>
                    <div class="flex" style="justify-content: flex-end;">
                        <button type="button" class="btn" @click.stop="onBulkSendingSave()">Сохранить изменения</button>
                        <button type="button" class="btn" @click.stop="closeModal('ppReceiversShedule')">Закрыть</button>
                    </div>
                </div>
            </div>
        </popup-window>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import moment from 'moment'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import UI from '../helpers/ui-helpers'
    import config from '../config'

    let backendApi = new BackendApi();
    const rowsPerPage = 30;

    const MinActivityEnum = {
        Day15: {Text: 'не заходил более 15 дней', Value: 15},
        Day30: {Text: 'не заходил более 35 дней', Value: 30},
        Day45: {Text: 'не заходил более 45 дней', Value: 45}
    };
    const MaxActivityEnum = {
        Day5: {Text:'заходил более 5 раз в месяц', Value: 5},
        Day15: {Text:'заходил более 15 раз в месяц', Value: 15},
        Day30: {Text:'заходил более 30 раз в месяц', Value: 30}
    };
    const MinBonusEnum = {
        1: {Text: 'больше нуля', Value: 1},
        1000: {Text: 'больше 1000', Value: 1000},
        5000: {Text: 'больше 5000', Value: 5000},
        10000: {Text: 'больше 10000', Value: 10000}
    };


    let processFilter = function (filter) {
        let filterCopy = JSON.parse(JSON.stringify(filter));
        if (filterCopy == null) {
            return null;
        }
        let stateEnums = {
            '[dbo].[AspNetUsers].[TermsConfirmed]': {
                'Да': 1,
                'Нет': 0
            },
            '[dbo].[AspNetUsers].[PersonalDataEditingAccept]': {
                'Да': 1,
                'Нет': 0
            },
            '[dbo].[AspNetUsers].[NotificationsEnabled]': {
                'Да': 1,
                'Нет': 0
            },
            '[dbo].[AspNetUsers].[PassportVerificationState]': {
                'документы отсутствуют': 0,
                'проверь документы!': 1,
                'документы подтверждены': 2,
                'документы возвращены': 3
            },
            '[dbo].[AspNetUsers].[RegisterStatus]': {
                'неактивен': 0,
                'проверка': 1,
                'активен': 2,
                'отказано': 3,
                'отключен': 4,
                'заблокирован': 5
            },
            '[dbo].[AspNetUsers].[MinActivity]': {},
            '[dbo].[AspNetUsers].[MaxActivity]': {},
            '[dbo].[AspNetUsers].[MinBonus]': {}
        };
        for(let s in MinActivityEnum){
            stateEnums['[dbo].[AspNetUsers].[MinActivity]'][MinActivityEnum[s].Text] = MinActivityEnum[s].Value;
        }
        for(let s in MaxActivityEnum){
            stateEnums['[dbo].[AspNetUsers].[MaxActivity]'][MaxActivityEnum[s].Text] = MaxActivityEnum[s].Value;
        }
        for(let s in MinBonusEnum){
            stateEnums['[dbo].[AspNetUsers].[MinBonus]'][MinBonusEnum[s].Text] = MinBonusEnum[s].Value;
        }


        let resultFilter = [];
        for (let item of filterCopy) {
            let filterField = item[0];
            let dontPushItem = false;
            if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]'
                || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]'
                || filterField === '[dbo].[AspNetUsers].[RegisterStatus]' || filterField === '[dbo].[AspNetUsers].[MinActivity]'
                || filterField === '[dbo].[AspNetUsers].[MaxActivity]'|| filterField === '[dbo].[AspNetUsers].[MinBonus]') {

                let values = item[2].substring(1, item[2].length - 1).split(';').map(x => decodeURI(x)).map(x => {
                    let name = x.substring(1, x.length - 1);
                    let state = stateEnums[filterField][name];
                    return state;
                });

                if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]'
                    || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]'
                    || filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {

                    item[0] = `isnull(${filterField}%comma%0)`;

                    if (filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {
                        let dateFilters = values.filter(x => x === 4 || x === 5 || x === 2);
                        let statusFilters = values.filter(x => x !== 4 && x !== 5 && x !== 2);

                        let dateFilterPart = '';
                        if (dateFilters.length) {
                            if (values.indexOf(4) > -1 && values.indexOf(5) === -1) {
                                // только Отключен
                                dateFilterPart = '[dbo].[UserDynamicRoles].[DisabledDateTime] <= getdate() and ([dbo].[UserDynamicRoles].[BlockedDateTime] is null or [dbo].[UserDynamicRoles].[BlockedDateTime] > getdate())';
                            }
                            if (values.indexOf(5) > -1 && values.indexOf(4) === -1) {
                                // только Заблокирован
                                dateFilterPart = '[dbo].[UserDynamicRoles].[BlockedDateTime] <= getdate()';
                            }
                            if (values.indexOf(5) > -1 && values.indexOf(4) > -1) {
                                // оба фильтра
                                dateFilterPart = '([dbo].[UserDynamicRoles].[DisabledDateTime] <= getdate() or [dbo].[UserDynamicRoles].[BlockedDateTime] <= getdate())';
                            }

                            // если есть фильтр "Активен"
                            if(values.indexOf(2) > -1 ){
                                if(dateFilterPart){
                                    // если уже указаны фильтры Заблокирован или Отключен
                                    dateFilterPart = '( (' + dateFilterPart + ') or [dbo].[AspNetUsers].[RegisterStatus] = 2' + ')';
                                }else{
                                    // только фильтр Активен
                                    dateFilterPart = '[dbo].[AspNetUsers].[RegisterStatus] = 2 and ([dbo].[UserDynamicRoles].[BlockedDateTime] is null or [dbo].[UserDynamicRoles].[BlockedDateTime] > getdate())' +
                                        'and ([dbo].[UserDynamicRoles].[DisabledDateTime] is null or [dbo].[UserDynamicRoles].[DisabledDateTime] > getdate())';
                                }
                            }
                        }

                        if (statusFilters.length) {
                            item[2] = '(' + values.filter(x => x !== 4 && x !== 5 && x !== 2).map(function (item) {
                                return `${encodeURI(item)}`;
                            }).join(';') + ')';
                        }
                        else {
                            dontPushItem = true;
                        }

                        if (dateFilters.length && !statusFilters.length) {
                            resultFilter.push(['', '', dateFilterPart]);
                        }

                        if (dateFilters.length && statusFilters.length) {
                            dontPushItem = true;

                            resultFilter.push(['', '', '(' + item.join(' ') + ' or ' + dateFilterPart + ')']);
                        }

                    } else {
                        item[2] = '(' + values.map(function (item) {
                            return `${encodeURI(item)}`;
                        }).join(';') + ')';
                    }

                }
                else {
                    item[2] = '(' + values.map(function (item) {
                        return `'${encodeURI(item)}'`;
                    }).join(';') + ')';
                }
            }

            if (filterField === '[dbo].[AspNetUsers].[UserRole]') {
                item[0] = '[dbo].[DynamicRole]';
            }

            if (!dontPushItem) {
                resultFilter.push(item);
            }
        }

        return resultFilter;
    };

    let BulkSendingType = {
        sms: 1,
        email: 2,
        notification: 3
    };


    export default {
        name: "sender",

        props: ['info'],

        mixins: [projectMixin],

        data() {
            return {
                activeTab: 'email', //'history',
                filter: null,
                currentTemplate: {
                    Id: null,
                    Body: null,
                    Name: null,
                    Header: null
                },
                userFilters: [
                    {
                        Value: 'LastName', Name: 'Фамилия'
                    },
                    {
                        Value: 'FirstName', Name: 'Имя'
                    },
                    {
                        Value: 'PhoneNumber', Name: 'Телефон'
                    },
                    {
                        Value: 'Email', Name: 'Email'
                    },
                    {
                        Value: 'TermsConfirmed', Name: 'Согласен на условия'
                    },
                    {
                        Value: 'PersonalDataEditingAccept', Name: 'Согласен на обработку'
                    },
                    {
                        Value: 'NotificationsEnabled', Name: 'Согласен на рассылку'
                    },
                    {
                        Value: 'PassportVerificationState', Name: 'Статус документов'
                    },
                    {
                        Value: 'RegisterStatus', Name: 'Активность'
                    },
                    {
                        Value: 'MinActivity', Name: 'Минимальная активность'
                    },
                    {
                        Value: 'MaxActivity', Name: 'Максимальная активность'
                    },
                    {
                        Value: 'MinBonus', Name: 'Доступно баллов'
                    }
                ],
                roles: [],
                users: {
                    data: [],
                    page: 1,
                    loading: false,
                    canBeLoaded: true
                },
                usersCount: null,
                isMobile: UI.check_mobile(),
                dateSortType: 'RegisterDate',
                dateSortTypes: [
                    { Id: 'RegisterDate', Name: 'Дата регистрации' },
                    { Id: 'UserActivationDateTime', Name: 'Дата активации аккаунта' },
                    { Id: 'DisabledDateTime', Name: 'Дата отключения' },
                    { Id: 'BlockedDateTime', Name: 'Дата блокировки' },
                    { Id: 'LastActivityDate', Name: 'Дата последнего визита' },
                    { Id: 'BonusAccrualDate', Name: 'Дата начисления бонусов' }
                ],
                dateSortEmpty: false,
                roleId: null,
                dateStart: '',
                dateEnd: '',
                dateStartSent: '',
                timeStartSent: '',
                forceNewLoadNext: false,

                templates: [],
                smsTextInfo: {
                    symbolsLeft: 160,
                    symbolsTotal: 0,
                    messages: 0,
                    averagePrice: null
                },
                bulkSending: {
                    data: [],
                    page: 1,
                    loading: false,
                    canBeLoaded: true
                },
                log: {
                    data: [],
                    page: 1,
                    loading: false,
                    canBeLoaded: true
                },
                receivers: {
                    id: null,
                    data: [],
                    body: null,
                    page: 1,
                    loading: false,
                    canBeLoaded: true,
                    templateName: null,
                    bulkSendingType: null
                },
                bulkSendingTypes:[
                    { Id: null, Name: 'все' },
                    { Id: 1, Name: 'sms' },
                    {Id: 2, Name: 'email'},
                    {Id: 3, Name: 'уведомления'}
                ],
                historyBulkSendingType: null,
                historyDateStart: null,
                historyDateEnd: null,
                smtpSettings: [{Id: 1, Name: 'name-1'},{Id: 2, Name: 'name-2'}],
                smtpServerId: null,
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            display: false,
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    animation: {
                        animateScale: true,
                        animateRotate: true
                    },
                    tooltips: {
                        enabled: true
                    }
                },
                chartData: {
                    datasets: [{
                        data: [

                        ],
                        backgroundColor: [
                            'rgb(244, 255, 129)', 'rgb(114, 138, 154)', 'rgb(97, 216, 24)', 'rgb(239, 3, 72)'
                        ],
                    }],
                    labels: ['Отправлено', 'Не отправлено', 'Доставлено', 'Не доставлено']
                },
                smsLimits: null,
                allCurrentUsersSelected: true
            }
        },
        
        watch:{
            usersCount(){
                this.calculateSmsTextInfo();
            }
        },

        computed: {
            // AllCurrentUsersSelected(){
            //     console.info('l:', this.users.data.filter(x => x.Included).length)
            //     return this.users.data.filter(x => x.Included).length === this.users.data.length;
            // },

            showAddTemplateBtn() {
                return !this.templatesByCurrentType.some(x => x.Id === 0);
            },

            templatesByCurrentType() {
                let bulkSendingTypeId = 1;
                switch(this.activeTab) {
                    case 'email':
                        bulkSendingTypeId = 2;
                        break;
                    case 'notification':
                        bulkSendingTypeId = 3;
                        break;
                }
                return this.templates.filter(x => x.BulkSendingTypeId === bulkSendingTypeId);
            },

            activeBulkSendingTypeId() {
                let bulkSendingTypeId = 1;
                switch(this.activeTab) {
                    case 'email':
                        bulkSendingTypeId = 2;
                        break;
                    case 'notification':
                        bulkSendingTypeId = 3;
                        break;
                }
                return bulkSendingTypeId;
            },

            resultUsersCount() {
                if(this.allCurrentUsersSelected){
                    return this.usersCount - this.users.data.filter(x => !x.Included).map(x => x.Id).length;
                }else{
                    return this.users.data.filter(x => x.Included).map(x => x.Id).length;
                }
            },

            smsSendingAllowed(){
                return this.smsLimits != null && this.smsLimits.total - this.smsLimits.today - this.resultUsersCount >= 0;
            },

            startSendingText() {
                return this.activeTab === 'notification' ? 'Отправить уведомления' : 'Запустить рассылку';
            }
        },

        methods: {
            currentUsersSelectAll($event){
                let vm = this;
                for(let u of this.users.data){
                    u.Included = vm.allCurrentUsersSelected;
                }
            },

            onHistoryFilterClear(){
                this.historyBulkSendingType = null;
                this.historyDateStart = null;
                this.historyDateEnd = null;

                this.bulkSendingReload();
            },

            onPushTemplateVariable(variable) {
                if (this.activeTab === 'sms') {
                    let $smsBody = $(this.$refs['smsBody']);
                    let index = $smsBody.prop("selectionStart");
                    if (index != undefined) {
                        let arr = this.currentTemplate.Body ? this.currentTemplate.Body.split(''): [];
                        arr.splice(index, 0, variable);
                        this.currentTemplate.Body = arr.join('');
                    } else {
                        this.currentTemplate.Body += variable;
                    }
                }
                if(this.activeTab === 'email' || this.activeTab === 'notification') {
                    this.$refs['EmailBody'].insert(variable);
                }
            },

            onPushSheduleTemplateVariable(variable) {
                this.$refs['SheduleEmailBody'].insert(variable);
            },

            onReceiversClick(history) {
                this.$refs['ppReceivers'].show();

                this.receivers.id = history.Id;
                this.receivers.data = [];
                this.receivers.page = 1;
                this.receivers.loading = false;
                this.receivers.canBeLoaded = true;
                this.receivers.bulkSendingType = history.BulkSendingType;
                this.receivers.RecTotal = history.ReceiversCount;
                this.receivers.BulkSendingTypeId = history.BulkSendingTypeId;
                this.receivers.AllowEdit = history.AllowEdit;
                this.receiversLoadNext();
                console.info('onReceiversClick BulkSendingTypeId', this.receivers.BulkSendingTypeId, history.AllowEdit);
            },

            openCurrentUsers() {

                this.$refs['ppCurrentUsers'].show();

                if (!this.users.data.length || this.forceNewLoadNext) {
                    if(this.forceNewLoadNext){
                        this.forceNewLoadNext = false;
                    }
                    this.loadNext();
                }
            },

            ppCurrentUsersClosed() {
                this.calculateSmsTextInfo();

                if(this.activeTab === 'history') {
                    this.$refs['ppReceiversShedule'].show();
                }
            },

            onReceiversSheduleClick() {
                //return moment().startOf('day').seconds(seconds).format('HH:mm:ss');

                let vm = this;
                UI.blockUI('#app', 'Загрузка...');

                this.callApiWrapper(backendApi.bulkSending(this.receivers.id))
                    .then(function (response) {
                        if(response.hasError) {
                            if(response.status === 401) {
                                UI.toastr.error('Недостаточно прав');
                            }
                            else {
                                UI.toastr.error('Ошибка при загрузке уведомления');
                            }
                        } else {
                            vm.currentTemplate = response.data;
                            if(vm.currentTemplate.StartDate) {
                                vm.currentTemplate.StartDateFormatted = moment(vm.currentTemplate.StartDate).format('DD.MM.YYYY');
                                vm.currentTemplate.StartSendTimeFormatted = moment(vm.currentTemplate.StartDate).format('HH:mm:ss');
                            }

                            vm.closeModal('ppReceivers');
                            vm.$refs['ppReceiversShedule'].show();
                            //console.info('onReceiversClick', vm.currentTemplate, vm.receivers.id);

                            vm.allCurrentUsersSelected = false;
                            vm.currentUsersSelectAll();
                            vm.forceNewLoadNext = true;

                            _.filter(vm.receivers.data, (x) => {
                                let user = vm.users.data.filter(y => y.Id === x.UserId);
                                if(user.length > 0) {
                                    user[0].Included = true;
                                } else {
                                    vm.users.data.push({Id: x.UserId, Included: true, Fio: x.Fio, Email: '', PhoneNumber: ''});
                                }
                                x.Included = vm.receivers.data.filter(y => y.UserId === x.Id) != null;
                            });
                        }
                        UI.unblockUI('#app');
                    });
            },

            onTemplateSave() {
                let vm = this;
                let bulkSendingTypeId = this.activeBulkSendingTypeId;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        let saveObj = {
                            Id: vm.currentTemplate.Id,
                            ProjectId: vm.projectId,
                            Body: vm.currentTemplate.Body,
                            Name: vm.currentTemplate.Name,
                            BulkSendingTypeId: bulkSendingTypeId,
                            Header: vm.currentTemplate.Header
                        };

                        UI.blockUI('#app', 'Сохранение...');
                        this.callApiWrapper(backendApi.bulkSendingTemplateSave(saveObj)).then(function (response) {
                            if (response.hasError) {
                                if (response.status === 401) {
                                    UI.toastr.error('Недостаточно прав');
                                }
                                else {
                                    UI.toastr.error('Ошибка при сохранении проекта');
                                }
                            } else {
                                vm.currentTemplate.Id = response.data;
                                vm.loadTemplates();
                            }

                            UI.unblockUI('#app');
                        });
                    }
                });
            },

            onStartSending() {
                let vm = this;

                if (vm.activeTab === 'email' && !this.currentTemplate.Name) {
                    UI.toastr.error('Укажите тему письма');
                }
                else {
                    if (confirm('Вы уверены что хотите запустить рассылку по выбранным пользователям?')) {
                        let notIncluded;
                        if(vm.allCurrentUsersSelected){
                            notIncluded = this.users.data.filter(x => !x.Included).map(x => x.Id);
                        }else{
                            notIncluded = this.users.data.filter(x => x.Included).map(x => x.Id);
                        }

                        let filterFormatted = '';
                        if(this.filter){
                            filterFormatted = processFilter(this.filter).map(x => {return JSON.stringify(x)});
                        }
                        let saveObj = {
                            TemplateId: this.currentTemplate.Id,
                            NotIncluded: notIncluded,
                            Filter: filterFormatted,
                            ProjectId: this.projectId,
                            TemplateName: this.currentTemplate.Name,
                            Body: this.currentTemplate.Body,
                            BulkSendingTypeId: this.activeBulkSendingTypeId,
                            SmtpServerId: this.smtpServerId,
                            RoleId: this.roleId,
                            DateSortEmpty: this.dateSortEmpty,
                            DateSortType: this.dateSortType,
                            DateStart: moment(this.dateStart, 'DD.MM.YYYY').format(),
                            DateEnd: moment(this.dateEnd, 'DD.MM.YYYY').format(),
                            AllCurrentUsersSelected: this.allCurrentUsersSelected,
                            Header: this.currentTemplate.Header,
                            DateStartSent: moment(this.dateStartSent + ' ' + this.timeStartSent, 'DD.MM.YYYY HH:mm:ss').format()
                        };
                        console.info('commonBulkSending', saveObj);
                        this.callApiWrapper(backendApi.commonBulkSending(saveObj))
                            .then(function (response) {
                                if (response.hasError) {
                                    if (response.status === 401) {
                                        UI.toastr.error('Недостаточно прав');
                                    }
                                    else {
                                        UI.toastr.error('Ошибка при создании рассылки');
                                    }
                                } else {
                                    UI.toastr.success('Успешно создано');
                                    vm.onTabChange('history');
                                }

                                UI.unblockUI('#app');
                            });
                    }
                }
            },

            onSendToMe() {
                let vm = this;
                UI.blockUI('#app', 'Отправка...');

                this.callApiWrapper(backendApi.bulkSendingTest(this.currentTemplate.Body, this.currentTemplate.Name, this.activeBulkSendingTypeId, this.smtpServerId, this.projectId, this.currentTemplate.Header))
                    .then(function (response) {
                    if (response.hasError) {
                        if (response.status === 401) {
                            UI.toastr.error('Недостаточно прав');
                        }
                        else {
                            UI.toastr.error('Ошибка при отправке');
                        }
                    } else {
                        UI.toastr.success('Успешно отправлено');
                        if(vm.info) {
                            vm.info.NotificationsLength = vm.info.NotificationsLength + 1;
                        }
                    }

                    UI.unblockUI('#app');
                });
            },

            onRemoveTemplate(template, index) {
                let vm = this;
                if (confirm('Удалить шаблон?')) {
                    let bulkSendingTypeId = 1;
                    if (this.activeTab === 'email') {
                        bulkSendingTypeId = 2;
                    }

                    let currentIndex = -1;
                    for (let i = 0; i < this.templates.length; i++) {
                        if (this.templates[i].BulkSendingTypeId === bulkSendingTypeId) {
                            currentIndex++;
                            if (currentIndex === index) {

                                if (this.templates[i].Id > 0) {
                                    UI.blockUI('#app', 'Сохранение...');
                                    this.callApiWrapper(backendApi.bulkSendingTemplateDelete(this.templates[i].Id)).then(function (response) {
                                        if (response.hasError) {
                                            if (response.status === 401) {
                                                UI.toastr.error('Недостаточно прав');
                                            }
                                            else {
                                                UI.toastr.error('Ошибка при удалении шаблона');
                                            }
                                        } else {
                                            vm.templates.splice(i, 1);
                                        }

                                        UI.unblockUI('#app');
                                    });
                                } else {
                                    this.templates.splice(i, 1);
                                }
                                break;
                            }
                        }
                    }
                }
            },

            onBulkSendingSave() {
                let id = this.receivers.id;
                let vm = this;
                vm.currentTemplate.StartDate =
                    moment(vm.currentTemplate.StartDateFormatted + ' ' + vm.currentTemplate.StartSendTimeFormatted, 'DD.MM.YYYY HH:mm:ss').format();
                let filterFormatted = '';
                if(this.filter) {
                    filterFormatted = processFilter(this.filter).map(x => {return JSON.stringify(x)});
                }
                let notIncluded;
                if(vm.allCurrentUsersSelected) {
                    notIncluded = this.users.data.filter(x => !x.Included).map(x => x.Id);
                } else {
                    notIncluded = this.users.data.filter(x => x.Included).map(x => x.Id);
                }

                let saveObj = {
                    Id: id,
                    Name: vm.currentTemplate.Name,
                    Header: vm.currentTemplate.Header,
                    Body: vm.currentTemplate.Body,
                    StartDateSent: vm.currentTemplate.StartDate,
                    RoleId: this.roleId,
                    DateSortEmpty: this.dateSortEmpty,
                    DateSortType: this.dateSortType,
                    DateStart: moment(this.dateStart, 'DD.MM.YYYY').format(),
                    DateEnd: moment(this.dateEnd, 'DD.MM.YYYY').format(),
                    Filter: filterFormatted,
                    NotIncluded: notIncluded,
                    AllCurrentUsersSelected: this.allCurrentUsersSelected,
                };
                
                UI.blockUI('#app', 'Сохранение...');

                this.callApiWrapper(backendApi.bulkSendingSave(saveObj))
                    .then(function (response) {
                        if(response.hasError) {
                            if(response.status === 401) {
                                UI.toastr.error('Недостаточно прав');
                            } else if(response.status === 203) {
                                UI.toastr.error('Уведомление было отправлено ранее. Изменения невозможны');
                                let bs = vm.bulkSending.data.filter(x => x.Id === id)[0];
                                if(bs) {
                                    bs.AllowEdit = false;
                                }
                                vm.closeModal('ppReceiversShedule');
                            }
                            else {
                                UI.toastr.error('Ошибка при сохранении уведомления');
                            }
                        } else {
                            UI.toastr.success('Уведомление успешно сохранено');
                            //let bs = vm.bulkSending.data.filter(x => x.Id === id)[0];
                            //if(bs) {
                            //    //bs.AllowEdit = false;
                            //    bs.Header = saveObj.Header;
                            //    bs.Header = saveObj.Header;
                            //    bs.Header = saveObj.Header;
                            //}

                            vm.closeModal('ppReceiversShedule');
                        }
                        UI.unblockUI('#app');
                    });
            },

            onBulkSendingDelete() {
                if(!confirm('Вы уверены что хотите отменить данное уведомление?')) {
                    return;
                }
                let id = this.receivers.id;
                console.info('onDeleteBulkSending', id);
                let vm = this;
                UI.blockUI('#app', 'Отмена...');

                this.callApiWrapper(backendApi.bulkSendingDelete(id))
                    .then(function (response) {
                        if(response.hasError) {
                            if(response.status === 401) {
                                UI.toastr.error('Недостаточно прав');
                            } else if(response.status === 203) {
                                UI.toastr.error('Уведомление было отправлено ранее. Изменения невозможны');
                                let bs = vm.bulkSending.data.filter(x => x.Id === id)[0];
                                if(bs) {
                                    bs.AllowEdit = false;
                                }
                                vm.closeModal('ppReceiversShedule');
                            }
                            else {
                                UI.toastr.error('Ошибка при удалении уведомления');
                            }
                        } else {
                            UI.toastr.success('Уведомление успешно удалено');
                            vm.bulkSending.data = vm.bulkSending.data.filter(x => x.Id !== id);

                            vm.closeModal('ppReceiversShedule');
                        }
                        UI.unblockUI('#app');
                    });
            },

            loadTemplates() {
                let vm = this;

                return this.callApiWrapper(backendApi.bulkSendingTemplates(vm.projectId))
                    .then(function (resp) {
                        if (resp.data) {
                            vm.templates = resp.data;
                        }
                    });
            },

            calculateSmsTextInfo() {
                let formattedBody = ((this.currentTemplate && this.currentTemplate.Body) ? this.currentTemplate.Body : '')
                    .replace('%ФИО%', '111111111111111111111111') // 24
                    .replace('%Фамилия%', '11111111') // 8
                    .replace('%Имя%', '11111111') // 8
                    .replace('%Отчество%', '11111111') // 8
                    .replace('%БаллыАктивные%', '11111') // 5
                    .replace('%БаллыПотенциальные%', '11111') // 5
                    .replace('%АктивацияАккаунта%', '')
                    .replace('%БаллыТекМесяц%', '11111'); // 5

                let total = formattedBody.length;
                let onlyEnglish = false;
                if(this.currentTemplate){
                    onlyEnglish = (/^[A-Z0-9]*$/ig).test(this.currentTemplate.Body);
                }

                let maxSymbolsForMessage = 70;
                if (total > 70){
                    maxSymbolsForMessage = 67;
                }

                if (onlyEnglish) {
                    maxSymbolsForMessage = 160;
                    if (total > 160) {
                        maxSymbolsForMessage = 154;
                    }
                }

                this.smsTextInfo.messages = Math.floor(total / maxSymbolsForMessage) + (total > 0 ? 1 : 0);
                this.smsTextInfo.symbolsLeft = maxSymbolsForMessage * (this.smsTextInfo.messages > 0 ? this.smsTextInfo.messages : 1) - total;
                this.smsTextInfo.symbolsTotal = total;

                this.smsTextInfo.averagePrice = (2.89 * this.smsTextInfo.messages * this.resultUsersCount).toFixed(2);
            },

            addTemplate() {
                let bulkSendingTypeId = 1;
                if (this.activeTab === 'email') {
                    bulkSendingTypeId = 2;
                }
                let newTemplate = {
                    Id: 0,
                    Name: 'Новый шаблон',
                    Body: '',
                    BulkSendingTypeId: bulkSendingTypeId,
                    CreateDate: new Date(),
                    CreatorFio: this.info.User.Fio
                };

                this.templates.push(newTemplate);
                this.currentTemplate = newTemplate;
            },

            onTemplateSelect(template) {
                let vm = this;
                      
                if (!this.currentTemplate || this.currentTemplate.Id != template.Id) {
                    this.users.data = [];
                }
                this.currentTemplate = template;

                if (this.activeTab === 'sms') {
                    this.calculateSmsTextInfo();
                }
                if(this.activeTab === 'email' || this.activeTab === 'notification') {
                    this.$nextTick(() => {
                        vm.$refs['EmailBody'].setHtml(template.Body);
                    });
                    this.calculateSmsTextInfo();
                }
            },

            onTabChange(tab) {
                let vm = this;
                      
                this.activeTab = tab;
                this.currentTemplate = null;

                if(tab === 'history'){
                    this.bulkSendingReload();
                }

                //if(tab === 'sms' || tab === 'email' || tab === 'notification') {
                    this.currentTemplate = {
                        Id: null,
                        Body: null,
                        Name: null,
                        Header: null
                    };
                //}
                if(tab === 'email' || tab === 'notification') {
                  this.$nextTick(() => {
                      vm.$refs['EmailBody'].setHtml('');
                  });
                }
                if(tab === 'log'){
                    this.log.data = [];
                    this.log.page = 1;
                    this.loadLogNext();
                }
                if(tab === 'sms'){
                    this.loadSmsLimits();
                }
            },

            loadSmsLimits(){
                let vm = this;
                UI.blockUI('#app');

                return this.callApiWrapper(backendApi.smsLimits())
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки информации по лимитам сообщений');
                        }
                        else {
                            if (resp.data) {
                                vm.smsLimits = resp.data;
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback) {
                let vm = this;
                if (columnName === 'TermsConfirmed' || columnName === 'PersonalDataEditingAccept' || columnName === 'NotificationsEnabled') {
                    callback(['Да', 'Нет']);
                }
                else if (columnName === 'PassportVerificationState') {
                    callback(['документы отсутствуют', 'проверь документы!', 'документы подтверждены', 'документы возвращены']);
                }
                else if (columnName === 'RegisterStatus') {
                    callback(['неактивен', 'проверка', 'активен', 'отказано', 'отключен', 'заблокирован']);
                }
                else if (columnName === 'MinActivity') {
                    callback([MinActivityEnum.Day15.Text, MinActivityEnum.Day30.Text, MinActivityEnum.Day45.Text]);
                }
                else if (columnName === 'MaxActivity') {
                    callback([MaxActivityEnum.Day5.Text, MaxActivityEnum.Day15.Text, MaxActivityEnum.Day30.Text]);
                }
                else if (columnName === 'MinBonus') {
                    callback([MinBonusEnum["1"].Text, MinBonusEnum["1000"].Text, MinBonusEnum["5000"].Text, MinBonusEnum["10000"].Text]);
                }
                else {
                    let filterFormatted = '';
                    if (filters) {
                        filterFormatted = processFilter(filters).map(x => {
                            return JSON.stringify(x)
                        });
                    }

                    this.callApiWrapper(backendApi.userDistinctValues(columnName, vm.projectId, search, filterFormatted,
                        (searchPage - 1) * 30, 30))
                        .then(function (resp) {
                            callback(resp.data);
                        })
                }
            },

            onFilterChange(filter) {
                console.info('onFilterChange', filter);
                this.filter = filter;
                this.users.data = [];
                this.loading = false;
                this.canBeLoaded = true;
                this.page = 1;

                this.loadUsersCount();
                this.loadNext();
            },

            loadRoles() {
                let vm = this;
                return this.callApiWrapper(backendApi.rolesList(vm.projectId))
                    .then(function (resp) {
                        if (resp.data) {

                            for (let r = 0; r < resp.data.Roles.length; r++) {
                                vm.roles.push({
                                    Id: resp.data.Roles[r].Id,
                                    Name: resp.data.Roles[r].Name,
                                    Claims: resp.data.Roles[r].Claims
                                });
                                if (vm.roleId == null && resp.data.Roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.bonusSpend)) {
                                    vm.roleId = resp.data.Roles[r].Id;
                                }
                            }

                        }
                    });
            },

            loadNext() {
                let vm = this;

                vm.users.loading = true;
                UI.blockUI('#app', 'Загрузка...');

                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY'),
                    dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY');
                if((dateStart.year() || 0) < 2000){
                    dateStart = null;
                }
                if((dateEnd.year() || 0)  < 2000){
                    dateEnd = null;
                }

                //console.info('loadNext->[dateStart, dateEnd]', [dateStart, dateEnd]);

                this.callApiWrapper(backendApi.usersList((this.users.page - 1) * rowsPerPage, rowsPerPage, vm.projectId, processFilter(vm.filter), this.roleId, this.dateSortEmpty,
                    vm.dateSortType, dateStart ? dateStart.format() : null, dateEnd ? dateEnd.format() : null))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки пользователей');
                        }
                        else {
                            if(resp.data && resp.data.length) {
                                if(vm.activeTab === 'history') {
                                    console.info('loadNext->[dateStart, dateEnd]', resp.data);
                                    _.filter(resp.data, (x) => {
                                        let user = vm.users.data.filter(y => y.Id === x.Id);
                                        if(user.length === 0) {
                                            vm.users.data.push({Id: x.Id, Included: false, Fio: x.Fio, Email: x.Email, PhoneNumber: x.PhoneNumber});
                                        }
                                    });
                                } else {
                                    for(let i = 0; i < resp.data.length; i++) {
                                        resp.data[i].Included = vm.allCurrentUsersSelected;
                                    }
                                    vm.users.data.push(...resp.data);
                                }
                            }
                            else {
                                vm.users.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('#app');
                        vm.users.loading = false;
                    })
            },

            loadLogNext() {
                let vm = this;

                vm.log.loading = true;
                UI.blockUI('#app', 'Загрузка...');

                this.callApiWrapper(backendApi.bulkSendingLogs((this.log.page - 1) * rowsPerPage, rowsPerPage, vm.projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки сервисных сообщений');
                        }
                        else {
                            if (resp.data && resp.data.length) {
                                vm.log.data.push(...resp.data);
                            }
                            else {
                                vm.log.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('#app');
                        vm.log.loading = false;
                    })
            },

            onCurrentUsersSroll() {
                let vm = this;

                if (!vm.users.loading && vm.users.canBeLoaded) {
                    vm.users.page++;
                    vm.loadNext();
                }
            },

            receiversLoadNext() {
                let vm = this;

                vm.receivers.loading = true;
                UI.blockUI('#app', 'Загрузка...');
                this.callApiWrapper(backendApi.bulkSendingReceiversList((this.receivers.page - 1) * rowsPerPage, rowsPerPage, this.receivers.id))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки пользователей');
                        }
                        else {
                            if (resp.data && resp.data.list.length) {
                                for(let i = 0; i < resp.data.list.length; i++){
                                    let statusFormatted = 'Не отправлено';
                                    if(resp.data.list[i].SentDate != null && resp.data.list[i].Sent === true
                                        || vm.receivers.BulkSendingTypeId === BulkSendingType.notification && !vm.receivers.AllowEdit) {
                                        statusFormatted = 'Отправлено';
                                    }
                                    if(resp.data.list[i].DeliveredDate != null && resp.data.list[i].Delivered === true){
                                        statusFormatted = 'Доставлено';
                                    }
                                    if(resp.data.list[i].DeliveredDate != null && resp.data.list[i].Delivered === false){
                                        statusFormatted = 'Не доставлено';
                                    }
                                    if(resp.data.list[i].Dublicate){
                                        statusFormatted = 'Дубликат';
                                    }

                                    resp.data.list[i].StatusFormatted = statusFormatted;
                                }
                                vm.receivers.data.push(...resp.data.list);

                                let stats = resp.data.bulkSendingStat;

                                vm.receivers.body = stats.Body;
                                vm.receivers.templateName = stats.TemplateName;

                                if(vm.receivers.page === 1){
                                    vm.chartData = {
                                        datasets: [{
                                            data: [
                                                stats.NotSentCount,
                                                (stats.SentCount - stats.NotDeliveredCount - stats.DeliveredCount),
                                                stats.NotDeliveredCount,
                                                stats.DeliveredCount
                                            ],
                                            backgroundColor: [
                                                'rgb(114, 138, 154)', 'rgb(244, 255, 129)', 'rgb(239, 3, 72)', 'rgb(97, 216, 24)'
                                            ],
                                        }],
                                        labels: ['Не отправлено', 'Отправлено', 'Не доставлено', 'Доставлено']
                                    };
                                }

                            }
                            else {
                                vm.receivers.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('#app');
                        vm.receivers.loading = false;
                    })
            },

            onReceiversSroll() {
                let vm = this;

                if (!vm.receivers.loading && vm.receivers.canBeLoaded) {
                    vm.receivers.page++;
                    vm.receiversLoadNext();
                }
            },

            loadUsersCount() {
                let vm = this;

                vm.loading = true;
                UI.blockUI('#app', 'Загрузка...');
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY'),
                    dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY');
                if((dateStart.year() || 0) < 2000){
                    dateStart = null;
                }
                if((dateEnd.year() || 0)  < 2000){
                    dateEnd = null;
                }

                this.callApiWrapper(backendApi.usersCount(vm.projectId, processFilter(vm.filter), this.roleId, this.dateSortEmpty,
                    vm.dateSortType, dateStart ? dateStart.format() : null, dateEnd ? dateEnd.format() : null))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки пользователей');
                        }
                        else {
                            if (resp.data != null) {

                                vm.users.page = 1;
                                vm.users.data = [];
                                vm.users.canBeLoaded = true;
                                vm.users.loading = false;

                                vm.usersCount = resp.data;
                            }
                            else {
                                vm.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('#app');
                        vm.loading = false;
                    })
            },

            onProjectChange(item) {
                let vm = this;
                this.projectId = item.Id;

                this.users.page = 1;
                this.users.data = [];
                this.users.canBeLoaded = true;
                this.users.loading = false;
                this.roles = [];

                this.bulkSending.page = 1;
                this.bulkSending.loading = false;
                this.bulkSending.canBeLoaded = false;
                this.bulkSending.data = [];

                vm.loadRoles().then(function () {
                    // if(vm.roles.length){
                    //     vm.roleId = vm.roles[0].Id;
                    // }
                    vm.loadUsersCount();
                    vm.loadTemplates();
                    vm.bulkSendingLoadNext();
                });
                this.$emit('user-updated');
            },

            onRoleChange(item) {
                this.loadUsersCount();
                this.forceNewLoadNext = true;
            },

            onRoleChangeFromPopup(){
                this.loadUsersCount();
                this.forceNewLoadNext = true;
                this.loadNext();
            },

            onDateChange() {
                this.loadUsersCount();
                this.loadNext();
                //this.forceNewLoadNext = true;
            },

            onSortTypeChange() {
                this.loadUsersCount();
                this.loadNext();
                //this.forceNewLoadNext = true;
            },

            onDateSortEmptyChange(){
                this.loadUsersCount();
                this.loadNext();
                //this.forceNewLoadNext = true;
            },

            clearFilterState() {
                this.dateStart = '';
                this.dateEnd = '';
                this.dateSortType = 'DateRegister';
                this.dateSortEmpty = false;

                for (let r = 0; r < this.roles.length; r++) {
                    if (this.roles[r].Claims.find(x => x.ClaimId === this.claimEnums.bonusSpend)) {
                        this.roleId = this.roles[r].Id;
                    }
                }

                localStorage.removeItem('senderCurrentUsersFilterKey');
                this.filter = null;
                this.loadUsersCount();
                this.loadNext();
            },

            bulkSendingReload() {
                this.bulkSending.page = 1;
                this.bulkSending.loading = false;
                this.bulkSending.canBeLoaded = false;
                this.bulkSending.data = [];
                this.bulkSendingLoadNext();
            },

            bulkSendingLoadNext() {
                let vm = this;

                vm.bulkSending.loading = true;
                UI.blockUI('#app', 'Загрузка...');

                console.info('loadNext->[dateStart, dateEnd]', [moment(vm.historyDateStart, 'DD.MM.YYYY').format(),  moment(vm.historyDateEnd, 'DD.MM.YYYY').format()]);
                this.callApiWrapper(backendApi.bulkSendingList((this.bulkSending.page - 1) * rowsPerPage, rowsPerPage,
                    vm.historyBulkSendingType, vm.projectId, moment(vm.historyDateStart, 'DD.MM.YYYY').format(), moment(vm.historyDateEnd, 'DD.MM.YYYY').format()))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки пользователей');
                        }
                        else {
                            if (resp.data && resp.data.length) {

                                vm.bulkSending.data.push(...resp.data);

                            }
                            else {
                                vm.bulkSending.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('#app');
                        vm.bulkSending.loading = false;
                    })
            },

            loadSmtpSettings() {
                let vm = this;

                return this.callApiWrapper(backendApi.smtpSettings())
                    .then(function (resp) {
                        if (resp.data) {

                            vm.smtpSettings = resp.data;

                        }
                    });
            },

            onCurrentUsersExport() {
                let vm = this;
                let projectId = vm.projectId,
                    roleId = vm.roleId,
                    dateSortEmpty = vm.dateSortEmpty,
                    dateSortType = vm.dateSortType,
                    notIncluded = vm.users.data.filter(x => !x.Included).map(x => x.Id);
                let dateStart = vm.dateStart && moment(vm.dateStart, 'DD.MM.YYYY').toISOString();
                let dateEnd = vm.dateEnd && moment(vm.dateEnd, 'DD.MM.YYYY').toISOString();
                
                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.userExport(projectId, processFilter(vm.filter), roleId, dateSortEmpty, dateSortType, dateStart, dateEnd, notIncluded.join(',')))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'Пользователи.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }

                        UI.unblockUI('#app');
                    });
            },

            getFilterForUri(){
                let str = '';
                if(this.filter) {
                    let processedFilter = processFilter(this.filter);
                    for (let i = 0; i < processedFilter.length; i++) {
                        let item = processedFilter[i];
                        str += `&filter[${i}]=${JSON.stringify(item)}`;
                    }
                }
                return str;
            },

            onExportDetails(bulkSendingId) {
                //let guid = this.generateGuid();
                let vm = this;
                let timeZone = new Date().getTimezoneOffset();
                let dateStart = vm.historyDateStart && moment(vm.historyDateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                let dateEnd = vm.historyDateEnd && moment(vm.historyDateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                //console.info('export -> [dateStart, dateEnd]', [dateStart, dateEnd]);
                //UI.blockTillDownloaded(guid, '#app');
                //location.href = config.apiUrl + '/api/bulkSending/exportDetails?bulkSendingId=' + bulkSendingId + '&guid=' + guid +
                //'&historyBulkSendingType=' + this.historyBulkSendingType + '&projectId=' + this.projectId +
                //    '&startDate=' + (dateStart) + '&endDate=' + (dateEnd);

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.bulkSendingExportDetails(bulkSendingId, vm.historyBulkSendingType, vm.projectId, dateStart, dateEnd))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'Детализация рассылки.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onRepeat() {
                let vm = this;

                vm.closeModal('ppReceivers');
                //console.table(vm.receivers.bulkSendingType)
                vm.activeTab = vm.receivers.bulkSendingType.toLowerCase();

                vm.currentTemplate = {
                    Id: null,
                    Body: vm.receivers.body,
                    Name: vm.receivers.templateName
                };

                if (vm.receivers.bulkSendingType === 'Email') {
                    vm.$nextTick(() => {
                        vm.$refs['EmailBody'].setHtml(vm.receivers.body);
                        vm.calculateSmsTextInfo();
                    });
                }
                else {
                    this.loadSmsLimits();
                    this.calculateSmsTextInfo();
                }

                // todo: подгрузить выбранную роль, фильтры и выбранных пользователей для отправки
            }
        },

        mounted() {
            let vm = this;
            Promise.all([vm.loadRoles()]).then(function () {
                vm.loadUsersCount();
                vm.loadTemplates();
                vm.bulkSendingLoadNext();
                vm.loadSmtpSettings();
            });
        }
    }
</script>
<style>
    .material-body{
        overflow: auto !important;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/Sender.vue